import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useStore } from '@/store';
import { useInitialState } from '@/hooks/useInitialState';
import LazyComponent from '@/components/LazyComponent';
import { useNavigation } from '@/hooks/useNavigation';

import AdminRoutes from '@/route/Admin';
import StudentRoutes from '@/route/Student';
import TeacherRoutes from '@/route/Teacher';

import Loading from '@/components/Loading';
import { Toaster } from '@/components/ui/sonner';

const Layout = React.lazy(() => import('@/layouts/index.tsx'));

const LoginPage = React.lazy(() => import('@/pages/Login'));

// 内部组件：用于初始化导航工具
function AppContent() {
  const navigate = useNavigate();
  const { initialState } = useInitialState();
  const { setNavigate } = useNavigation();

  const adminRoutes = AdminRoutes();
  const studentRoutes = StudentRoutes();
  const teacherRoutes = TeacherRoutes();

  // 初始化导航工具
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  // restore menus & menu
  useEffect(() => {
    initialState.init();
  }, []);

  return (
    <Routes>
      <Route path='/' element={<Navigate to='/login' replace />} />
      <Route
        path='/login'
        element={<LazyComponent AsyncComponent={LoginPage} />}
      ></Route>
      <Route path='/*' element={<LazyComponent AsyncComponent={Layout} />}>
        {adminRoutes}
        {studentRoutes}
        {teacherRoutes}
      </Route>
    </Routes>
  );
}

function App() {
  const { currentLoading } = useStore();
  return (
    <div className='App'>
      <AppContent />
      {currentLoading && <Loading />}
      <Toaster />
    </div>
  );
}

export default App;
